import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { get, store } from './../../utils/Storage'
import swal from 'sweetalert';

import './index.css'
import Logo from './../../assets/img/ares-logo.png'
import moment from 'moment';

import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

import http from './../../services/Api'
import { AiOutlineUser } from 'react-icons/ai'
import { Col, InputGroup, Row } from 'react-bootstrap'
import { RiKey2Line, RiLoader4Line } from 'react-icons/ri'
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../providers/auth';
import Axios from 'axios';
import config from '../../config'

export default function Login() {
	const { register, handleSubmit } = useForm();
	const [loading, setLoading] = useState(null);
	const history = useHistory();
	const user = get('user')
	const { setUser } = useAuth()
	const baseURL = config.getBaseUrl()

	useEffect(() => {
		user && history.push('/my-devices');
	}, [user]) // eslint-disable-line react-hooks/exhaustive-deps

	const verifyEmail = async email => {
		try {
			let response = await http.post(`/api/user/email-available`, { 'email': email });
			return response;
		} catch (e) {
			console.log(e)
			return e;
		}
	}

	const handleSocialLogin = async (user) => {
		const { _profile, _token, _provider } = user;
		const { idToken, accessToken } = _token;
		const { email, name, profilePicURL, id } = _profile;
		let image = profilePicURL
		let type = _provider
		let token = ''
		if (_provider === 'facebook') {
			token = accessToken
		} else {
			token = idToken
		}

		setLoading(true);

		try {
			let response = await http.post('/api/authenticate/social', {
				id,
				name,
				image,
				email,
				token,
				type
			})
			const { data } = response
			store('token', data['token'].token);
			store('user', data.user)
			localStorage.setItem('login_time', moment().add(5, 'minutes').toISOString())
			setLoading(false);
			window.location.href = '/my-devices'
		} catch (e) {
			alert(e.response.data.error)
		}
	}

	const handleSocialLoginFailure = (err) => {
		console.error(err)
	}

	const authenticate = async formData => {
		setLoading(true);
		const { username, password } = formData;
		try {
			let response = await http.post('/api/authenticate', {
				username,
				password
			})
			const { token, user } = response.data
			let enterpriseResponse = await Axios.get(`${baseURL}/api/user-client-id/${response.data.user._id}`, { headers: { Authorization: `Bearer ${token.token}` } });
			const enterprise = enterpriseResponse.data;
			store('token', token.token);
			store('user', user);
			store('enterprise', enterprise);
			localStorage.setItem('login_time', moment().add(5, 'minutes').toISOString())
			setUser({
				name: user.name,
				email: user.email,
				username: user.username
			})
			window.location.href = '/my-devices'
		} catch (e) {
			console.log(e);
			setLoading(false)
			swal("Erro!", e.response.data.error, "error");
		}
	}

	return (
		<>
			<div className="Login">
				<div className="content">
					<div className="left">
						<div className="container-img">
							<img src={Logo} alt="logo" />
						</div>
						<div className="copyright">
							Copyright © 2021 Synapse Brasil, Inc.
            			</div>
					</div>
					<div className="right">
						<Form method="POST" onSubmit={handleSubmit(authenticate)}>
							<div className="text-center">
								<h1>Login</h1>
							</div>
							<Form.Group>
								<InputGroup>
									<InputGroup.Prepend>
										<InputGroup.Text id="inputGroupPrepend">
											<AiOutlineUser size="1.2em" />
										</InputGroup.Text>
									</InputGroup.Prepend>
									<Form.Control name="username" type="text" ref={register} placeholder="Usuário" />
								</InputGroup>
							</Form.Group>
							<Form.Group>
								<InputGroup>
									<InputGroup.Prepend>
										<InputGroup.Text id="inputGroupPrepend">
											<RiKey2Line size="1.2em" />
										</InputGroup.Text>
									</InputGroup.Prepend>
									<Form.Control name="password" type="password" ref={register} placeholder="Senha" />
								</InputGroup>
							</Form.Group>
							<div className="auth-container">
								<Row >
									{/* <Col>
										<Button variant="default" type="button" onClick={
											() => window.location.href = '/register'
										}>
											Cadastrar
                					</Button>
									</Col> */}
									<Col>
										<Button variant="primary" type="submit">
											{loading ? (<RiLoader4Line className="spin" />) : 'Entrar'}
										</Button>
									</Col>
								</Row>
								<div className="forgot-password">
									<a href='/forgot-password'>Esqueceu a senha ?</a>
								</div>
							</div>
							{/* <div className="social">
								<Facebook
									className="facebook"
									type="button"
									provider='facebook'
									appId={FACEBOOK_CLIENT_ID}
									appId='833033114096761'
									onLoginSuccess={handleSocialLogin}
									onLoginFailure={handleSocialLoginFailure} >
									<FaFacebookF />
									<span>
										Login com Facebook
									</span>
								</Facebook>
								<Google
									className="google"
									type="button"
									provider='google'
									appId={GOOGLE_CLIENT_ID}
									appId='398291613828-2621ig26v7c9eo7srkslvcih2ggarumd.apps.googleusercontent.com'
									onLoginSuccess={handleSocialLogin}
									onLoginFailure={handleSocialLoginFailure} >
									<AiOutlineGoogle />
									<span>
										Login com Google
									</span>
								</Google>
								não é possível testar no ambiente local
								<Apple onLoginSuccess={handleSocialLogin} />
							</div> */}
							<div className="social-mobile">
								<Row>
									{/* <Col>
										<Facebook
											type="button"
											provider='facebook'
											appId={FACEBOOK_CLIENT_ID}
											// appId='833033114096761'
											onLoginSuccess={handleSocialLogin}
											onLoginFailure={handleSocialLoginFailure} >
											<FaFacebookF />
										</Facebook>
									</Col> */}
									{/* <Col>
										<Apple onLoginSuccess={handleSocialLogin} />
									</Col> */}
									{/* <Col>
										<Google
											type="button"
											provider='google'
											appId={GOOGLE_CLIENT_ID}
											// appId='398291613828-2621ig26v7c9eo7srkslvcih2ggarumd.apps.googleusercontent.com'
											onLoginSuccess={handleSocialLogin}
											onLoginFailure={handleSocialLoginFailure} >
											<AiOutlineGoogle />
										</Google>
									</Col> */}
								</Row>
							</div>
						</Form>
					</div>
					<section></section>
				</div>
			</div>
		</>
	)
}